'use strict';

var React = require('react');
var Thumbs = require('../../../collections/thumb-grids.jsx');

var CollectionsSegment = React.createClass({
    render: function() {
        // collections.php Collections::CollectionsAPI via page.php Page::homepage()
        var thumbs = Payload.extra.collections.filter((c) => {
            return c.seq != null;
        }).map(t => {
            t.alt = Payload.text['homepage.alt.collection.' + t.urlkey];
            return t;
        });
        return <Thumbs type='hero-tiered' thumbs={thumbs} />;
    }
});

module.exports = CollectionsSegment;



// WEBPACK FOOTER //
// ./src/pages/content/homepage/homepage-collections.jsx